import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sg2-elements-view',
  templateUrl: './elements-view.component.html',
  styleUrls: ['./elements-view.component.less']
})
export class ElementsViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
